import { roundToCents } from '../accounts-receivable/round-to-cents.js';
/** N16's "paid", judged at cents like AR and every screen, so a stray sub-cent residue never strands an order. */
export function isSalesOrderBalancePaid(balanceDue) {
    return roundToCents(balanceDue).lessThanOrEqualTo(0);
}
//# sourceMappingURL=is-sales-order-balance-paid.js.map